export default __webpack_public_path__ + "img/c2e0ccaa1f8d4d0a11c7d1ca10aca5f5.png";